import axios from 'axios'
import {ResponseObject} from '../../../../../models'
import {TermsModel} from '../models'
const BASEURL = process.env.REACT_APP_DEV_API_HOTELERIA_URL

export async function editTermsService(dto: TermsModel) {
  return await axios.put<ResponseObject<TermsModel>>(`${BASEURL}/terms/updateTerms`, dto)
}
